import { render, staticRenderFns } from "./DesignerActions.vue?vue&type=template&id=4fc3191d&scoped=true"
import script from "./DesignerActions.vue?vue&type=script&lang=js"
export * from "./DesignerActions.vue?vue&type=script&lang=js"
import style0 from "./DesignerActions.vue?vue&type=style&index=0&id=4fc3191d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc3191d",
  null
  
)

export default component.exports